// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/dist/bootstrap-vue.css
// module id = 9M+g
// module chunks = 1